import { Component, Input, OnInit } from '@angular/core';
import { HoleChargeView } from 'src/app/bo/blastModel/holeChargeView';

@Component({
  selector: 'app-holecharge-view',
  templateUrl: './holecharge-view.component.html',
  styleUrls: ['./holecharge-view.component.scss'],
  standalone: false
})
export class HoleChargeViewComponent implements OnInit {

  @Input() holeChargeView:HoleChargeView|undefined = undefined;
  
  constructor() { }

  ngOnInit(): void {
  }

  protected getGradient(color:string): string {
    return `linear-gradient(to right, ${this.darkenColor(color, 25)} 0%, ${color} 20%, ${color} 80% , ${this.darkenColor(color, 25)}  100%)`;
  }

  private darkenColor(hex: string, amount: number): string {
    let { h, s, l } = this.hexToHSL(hex);
    l = Math.max(0, l - amount); // Ensure lightness doesn't go below 0
    return `hsl(${h}, ${s}%, ${l}%)`;
}

  private hexToHSL(hex: string): { h: number, s: number, l: number } {
    // Convert hex to RGB first
    let r = parseInt(hex.slice(1, 3), 16);
    let g = parseInt(hex.slice(3, 5), 16);
    let b = parseInt(hex.slice(5, 7), 16);

    // Then to HSL
    r /= 255;
    g /= 255;
    b /= 255;
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    let h, s, l = (max + min) / 2;

    if (max === min) {
        h = s = 0; // achromatic
    } else {
        const d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch (max) {
            case r: h = (g - b) / d + (g < b ? 6 : 0); break;
            case g: h = (b - r) / d + 2; break;
            case b: h = (r - g) / d + 4; break;
        }
        h /= 6;
    }

    return { h: h * 360, s: s * 100, l: l * 100 };
}
}
